export enum TypeOutilPrelevement {
    Brosse = 1,
    Scalpel,
    Racloir
}
